import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import { toast } from "sonner";

export default function AdminSite() {
  const { authHeaders } = useAuth();
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/site/content").then((r) => setContent(r.data));
  }, []);

  const save = async () => {
    try {
      await api.put("/site/content", content, { headers: authHeaders() });
      toast.success("Site content updated!");
    } catch {
      toast.error("Error saving");
    }
  };

  if (!content) return <div>Loading...</div>;

  return (
    <div data-testid="admin-site">
      <h1 className="text-3xl font-extrabold mb-6">Site Content</h1>
      <div className="bg-white rounded-2xl border border-slate-200 p-8 space-y-5 max-w-3xl">
        <div>
          <label className="text-sm font-bold block mb-1">Hero Title</label>
          <Input value={content.hero_title || ""} onChange={(e) => setContent({ ...content, hero_title: e.target.value })} />
        </div>
        <div>
          <label className="text-sm font-bold block mb-1">Hero Subtitle</label>
          <Textarea value={content.hero_subtitle || ""} onChange={(e) => setContent({ ...content, hero_subtitle: e.target.value })} rows={3} />
        </div>
        <div>
          <label className="text-sm font-bold block mb-1">About Title</label>
          <Input value={content.about_title || ""} onChange={(e) => setContent({ ...content, about_title: e.target.value })} />
        </div>
        <div>
          <label className="text-sm font-bold block mb-1">About Body</label>
          <Textarea value={content.about_body || ""} onChange={(e) => setContent({ ...content, about_body: e.target.value })} rows={5} />
        </div>
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <label className="text-sm font-bold block mb-1">Phone</label>
            <Input value={content.phone || ""} onChange={(e) => setContent({ ...content, phone: e.target.value })} />
          </div>
          <div>
            <label className="text-sm font-bold block mb-1">Email</label>
            <Input value={content.email || ""} onChange={(e) => setContent({ ...content, email: e.target.value })} />
          </div>
        </div>
        <div>
          <label className="text-sm font-bold block mb-1">Address</label>
          <Input value={content.address || ""} onChange={(e) => setContent({ ...content, address: e.target.value })} />
        </div>
        <Button onClick={save} className="bg-brand-pink hover:bg-brand-pink-hover" data-testid="save-site">Save Changes</Button>
      </div>
    </div>
  );
}
